import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '@/components/shadcn/ui/dialog';
import { FileIcon } from 'lucide-react';
import { Button } from '@/components/shadcn/ui/button';
import { useAuthContext } from '@/context/AuthContext';
import { useBusiness } from '@/hook/useBusiness';
import { useParams } from 'react-router-dom';
import { Input } from '@/components/shadcn/ui/input';
import { useAttachments } from '@/hook/useAttachments';

function AtachmentsDialog() {
  const [file, setFile] = useState<File | null>(null);
  const [description, setDescription] = useState<string>(''); // Para armazenar a descrição do anexo
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const leadId = Number(useParams().leadId);
  const { accessToken } = useAuthContext();
  const { business2 } = useBusiness(leadId, accessToken?.userId);
  const {getBusinessAttachments} = useAttachments(leadId);

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const onDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDescription(e.target.value);
  };

  const onFileUpload = async () => {
    if (!file) {
      alert('Por favor, selecione um arquivo para enviar');
      return;
    }

    // Verificar se o 'businessId' está disponível
    if (!business2?.id) {
      alert('Não foi possível encontrar o ID do negócio');
      return;
    }

    // Montar os dados do formulário
    const formData = new FormData();
    formData.append('file', file);
    formData.append('description', description); // Adiciona a descrição
    formData.append('businessId', business2.id.toString()); // Passando o businessId

    try {
      const response = await axios.post('10.86.254.128:3001/files/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${accessToken?.token}`, // Enviando token de autorização (se necessário)
        },
      }); // Aqui você pode ver a resposta do servidor
      alert('Arquivo enviado com sucesso!');
      setIsDialogOpen(false); // Fecha o dialog após o upload
    } catch (error) {
      console.error('Erro no upload', error);
      alert('Erro no upload do arquivo');
    }
  };

  return (
    <div>
      {/* Botão que abre o Dialog */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogTrigger asChild>
          <Button title="Anexar Arquivos" className="flex gap-1 h-10 text-white text-sm text-slate-500 border bg-white hover:bg-indigo-100">
            <FileIcon size={20} className="text-slate-500" /> Anexos
          </Button>
        </DialogTrigger>

        <DialogContent className="p-4 max-w-lg mx-auto">
          <DialogHeader>
            <DialogTitle>
              <div className="flex items-center gap-2">
                <FileIcon size={20} className="text-slate-500" />
                Upload de Arquivos
              </div>
            </DialogTitle>
          </DialogHeader>

          {/* Formulário de upload */}
          <div className="space-y-4">
            <Input
              type="file"
              onChange={onFileChange}
              className="block w-full p-2 border border-gray-300 rounded"
            />
            <Input
              type="text"
              value={description}
              onChange={onDescriptionChange}
              placeholder="Descrição do arquivo (opcional)"
              className="block w-full p-2 border border-gray-300 rounded"
            />
          </div>

          <DialogFooter>
            <Button className="bg-gray-500 text-white p-2 rounded mr-2" onClick={() => setIsDialogOpen(false)}>
              Cancelar
            </Button>
            <Button className="bg-blue-500 text-white p-2 rounded" onClick={onFileUpload}>
              Enviar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default AtachmentsDialog;
